import React from "react";
import * as yup from "yup";
import { Form } from "react-final-form";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import UiInput from "../../../_uiComponents/common/form/UiInput";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Validator from "../../../../_helpers/validate.schema";
import { ajaxError, loginAuthRequest } from "../../../../_redux/_actions";
import UiCheckbox from "../../../_uiComponents/common/form/UiCheckBox";
import { getFingerPrint } from "../../../../_helpers/support.services";

const validateSchema = () =>
     yup.object().shape({
          email: yup
               .string()
               .required("Email is required.")
               .email("Email must be a valid email."),
          password: yup.string().required("Password is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export function SignInForm(props) {
     const handleLogin = () => {
          navigate(path);
     };

     const actionDispatch = useDispatch();
     const navigate = useNavigate();

     const submit = async (values) => {

		const browserFingerprint = await getFingerPrint();

          actionDispatch(
               loginAuthRequest({
                    ...values,
                    browserFingerprint,
                    validateOtp: false,
                    rememberBrowser: false,
                    navigate: navigate,
               }),
          );
     };

     return (
          <>
               <Box component="div" sx={{ width: "100%" }}>
                    <Form
                         onSubmit={submit}
                         validate={onValidate}
                         render={({ handleSubmit, hasValidationErrors }) => (
                              <form onSubmit={validateSchema}>
                                   <>
                                        <UiInput
                                             type="text"
                                             label="User name"
                                             name="email"
                                        />
                                        <UiInput
                                             type="password"
                                             label="Password"
                                             name="password"
                                        />

                                        {/* <Grid container>
                                             <Grid
                                                  item
                                                  xs={4}
                                                  sx={{ textAlign: "left" }}
                                             >
                                                  <UiCheckbox label="Remember me" />
                                             </Grid>
                                        </Grid> */}

                                        <Grid container sx={{ mb: 3 }}>
                                             <Grid
                                                  alignItems="center"
                                                  display="flex"
                                                  item
                                                  xs={6}
                                                  sx={{ textAlign: "left" }}
                                             >
                                                  <span
                                                       variant="body2"
                                                       className="sba-forgot-password-link"
                                                  >
                                                       Forgot your password?
                                                  </span>
                                             </Grid>
                                             <Grid
                                                  item
                                                  xs={6}
                                                  sx={{ textAlign: "right" }}
                                             >
                                                  <UiButton
                                                       name="Next"
                                                       variant="contained"
                                                       size="large"
                                                       onClick={handleSubmit}
                                                  />
                                             </Grid>
                                        </Grid>
                                   </>
                              </form>
                         )}
                    />
               </Box>
          </>
     );
}
